import React, { useState, useEffect } from 'react'
import { Table } from 'rsuite'
import { cloneDeep } from 'lodash-es'

export default function ProjectOrganizationView({ schema: _schema, ...props }) {
  const { Column, HeaderCell, Cell } = Table

  const [schema, setSchema] = useState(_schema)

  return (
    <div>
      <Table
        height={400}
        wordWrap
        autoHeight={schema?.values?.length <= 5}
        data={schema.values || []}
      >
        <Column width={100} align="center">
          <HeaderCell>ข้อที่</HeaderCell>
          <Cell>
            {(_, index) => {
              return <span>{index + 1}</span>
            }}
          </Cell>
        </Column>
        <Column width={120} flexGrow={1}>
          <HeaderCell align="center">บทบาทหน้าที่</HeaderCell>
          <Cell dataKey="responsibilityRole" />
        </Column>

        <Column width={120} flexGrow={1}>
          <HeaderCell align="center">ชื่อหน่วยงาน</HeaderCell>
          <Cell dataKey="organization" />
        </Column>
      </Table>
    </div>
  )
}
